export default __webpack_public_path__ + "static/marketing-card-1f2ed0352a654d098a623145528f4257.png";